<template>
  <div class="page">
    <div class="d-flex justify-content-center align-items-center">
      <div class="container">
        <div class="row" style="margin-top:20px">
          <div class="col-lg-6 col-md-12 mb-4">
            <div>
              <div class="generate col-lg-12 col-sm-12">
                 <!-- untuk grafik -->
                 <div class='content mt-4' style="background:white">
                    <div class="untukscroll">
                      <div class="content container">
                        {{countCluster}}
                        <div style="width:100%;height:465px;overflow:auto">
                          <chart :labels="labels" :chartData="chartData" :chartDataFalse="chartDataFalse" :chartDataTrue="chartDataTrue"></chart>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-12 mb-4">
            <div>
              <div class="generate col-lg-12 col-sm-12">
                <!-- Generate button -->
                <div class="input-group mt-4 mb-4">
                  <input type="text" @keyup.enter="searchGuest" v-model="search" autocomplete="off" class="form-control" placeholder="Search ..." required>
                  <span class="input-group-append">
                    <button type="button" class="btn-custom" @click="searchGuest">
                      <i class="fas fa-search"></i>
                    </button>
                  </span>
                </div>
                  <!-- Full Name & Instansi Information -->
                  <div class='content' style="background:white">
                    <div class="untukscroll">
                      <div class="content container">
                        <div v-if="!showSearch" class="table-responsive" style="width:100%;height:400px;overflow:auto">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col">No.</th>
                                <th scope="col">Name</th>
                                <th scope="col">Cluster</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(value, index) in attentData" :key="index" class="mb-1">
                                <td>{{index+1}}.</td>
                                <td>
                                    {{value.name}}
                                </td>
                                <td>{{value.cluster}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <!-- search form -->
                        <div v-if="showSearch" class="table-responsive" style="width:100%;height:400px;overflow:auto">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col">No.</th>
                                <th scope="col">Name</th>
                                <th scope="col">Cluster</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(value, index) in guestDataSearch" :key="index" class="mb-1">
                                <td>{{index+1}}.</td>
                                <td>
                                    {{value.name}}
                                </td>
                                <td>{{value.cluster}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modalUpdate :getGuestData="getGuestData" :guestId="guestId"></modalUpdate>
  </div>
</template>

<script>
import modalUpdate from '@/components/modalUpdate.vue'
import config from '@/config.js'
import chart from '@/components/chart.vue'

export default {
  components:{
    modalUpdate,
    chart
  },
  props : ['guestData','attentData', 'getGuestData'],
  data : function(){
    return {
      fullname : '',
      cluster : '',
      table : '',
      guestId : '',
      guestDataSearch : '',
      search : '',
      showSearch : false,
      countCluster : '',
      labels : [],
      chartData : [],
      chartDataFalse : [],
      chartDataTrue : []
    }
  },
  created : function(){
    this.getGuestData()
    let token = localStorage.getItem('token')
    if(!token){
      this.$router.push({ name : 'home' })
    }
    this.getChart()
  },
  watch : {
    fullname(){
      this.showQrcode = false
    },
    cluster(){
      this.showQrcode = false
    },
    search(){
      if(this.search.length === 0){
        this.guestDataSearch = ''
        this.showSearch = false
      }
      else{
        this.showSearch = true
      }
    }
  },
  methods : {
    sendId(value){
      this.guestId = value._id
    },
    updateGuest(){
      axios({
        method : 'PUT',
        url : `${config.port}/guests/update/guest/${this.guestId}`,
        headers : {
          token : localStorage.getItem('token')
        },
        data : {
          name : this.fullname,
          cluster : this.cluster,
          table : this.table
        }
      })
      .then(response => {
        this.getGuestData()
        this.fullname = ''
        this.cluster = ''
        this.table = ''
      })
      .catch(err => {
        console.log(err)
      })
    },
    searchGuest(){
      axios({
        method : 'GET',
        url : `${config.port}/guests/search/attent/${this.search}`,
        headers : {
          token : localStorage.getItem('token')
        }
      })
      .then(response => {
        this.guestDataSearch = response.data
      })
      .catch(err => {
        console.log(err)
      })
    },
    getChart(){
      function groupBy(objectArray, property) {
        return objectArray.reduce(function (acc, obj) {
          var key = obj[property];
          if (!acc[key]) {
            acc[key] = [];
          }
          acc[key].push(obj);
          return acc;
        }, {});
      }

      let data = groupBy(this.guestData, 'cluster');
      this.countCluster = Object.entries(data)
      .forEach(list => {
        console.log('ini list -->> ',list)
        let coba = groupBy(list[1], 'isAttent')
        console.log('attent', coba)
        this.labels.push(list[0])
        this.chartData.push(list[1].length)
        if(coba.true){
          this.chartDataTrue.push(coba.true.length)
        }
        if(!coba.true){
          this.chartDataTrue.push(0)
        }
        if(coba.false){
          this.chartDataFalse.push(coba.false.length)
        }
      })
    },
  }
}
</script>
<style scoped>
  .btn-custom-generate{
    background-color: #fa1199;
  }

</style>
